import { FC, ReactNode } from 'react';

import { Link } from 'react-router-dom';

import { TUserRoles, useUserRole } from '@entities/user';
import CopyToClipboardButton from '@features/copy-to-clipboard-button';
import { reduceString } from '@shared/utils/reduceString';

interface IProps {
  text: string;
  size?: number;
  needReduce?: boolean;
  navigateTo?: string;
  allowedNavigateRoles?: TUserRoles[];
}

const ReduceAndCopyString: FC<IProps> = ({
  text,
  needReduce = true,
  size = 4,
  navigateTo,
  allowedNavigateRoles,
}) => {
  const userRole = useUserRole();

  if (!text || text === 'null' || text === 'N/A') return null;

  const canNavigate = !allowedNavigateRoles || allowedNavigateRoles.includes(userRole);
  const displayText = needReduce ? reduceString({ text, size }) : text;

  let textContent: ReactNode;
  if (navigateTo && text !== 'N/A' && canNavigate) {
    textContent = <Link to={navigateTo}>{displayText}</Link>;
  } else {
    textContent = displayText;
  }

  return (
    <div className='table-cell-items' style={{ overflow: 'hidden' }}>
      <div>{textContent}</div>
      <CopyToClipboardButton text={text} />
    </div>
  );
};

export default ReduceAndCopyString;
